export const GET_GEN_SHAFT_UNBALANCE_RESULT = "GET_GEN_SHAFT_UNBALANCE_RESULT";
export const RESET_GEN_SHAFT_UNBALANCE_RESULT = "RESET_GEN_SHAFT_UNBALANCE_RESULT";
export const GET_GEN_SHAFT_UNBALANCE_CHART = "GET_GEN_SHAFT_UNBALANCE_CHART";
